import { TAKAYAMA_QUOTE } from './takayama.js';

/**
 * 物件ごとの備品見積り。CG の設計データ（plan）の id で引く。
 * 見積りがある物件では、3D の家具をクリックすると値段が出る。
 */
export const QUOTES = Object.freeze({ takayama: TAKAYAMA_QUOTE });

/** その plan の見積り。無ければ null */
export const quoteFor = (planId) => QUOTES[planId] ?? null;
